module.exports = __webpack_public_path__ + "img/flower-purple.f7e9afd7.png";